angular.module('impactx.warnings', []);